/* eslint-disable jsx-a11y/label-has-associated-control */

import React from "react";
import { useContext } from "../../../context";
import { CompleteIcon } from "../../../shared/CompleteIcon";

export function Consents() {
  const { appointment } = useContext();

  return (
    <div className="detail-row">
      <label>Consent(s):</label>
      <span>
        <CompleteIcon isCompleted={appointment.isConsentsCompleted} />
      </span>
    </div>
  );
}
